// Session recovery (query-cache clear + guard re-run) must fire only when the
// backend says the session itself is gone. These are the stable codes its auth
// middleware attaches to that verdict, on both the `/auth` and
// `/backoffice/auth` namespaces. Every other 401 code is a failed credential
// attempt the caller handles locally — wrong password, bad MFA/OTP code,
// invalid credential — so new credential-checking endpoints need no
// registration here: their failure codes are simply not in this set.
const SESSION_DEATH_CODES = new Set([
	'auth_credentials_missing',
	'auth_jwt_invalid',
	'session_invalid',
	'session_expired',
	'user_deleted',
	'backoffice_auth_credentials_missing',
	'backoffice_jwt_invalid',
	'backoffice_session_invalid',
	'backoffice_session_expired',
	'backoffice_admin_deleted'
])

export function isSessionDeathCode(code: string | undefined) {
	return code !== undefined && SESSION_DEATH_CODES.has(code)
}

/**
 * The two codes that mean «your CSRF token belongs to a session that is no
 * longer the current one», one per namespace.
 *
 * A separate set from {@link SESSION_DEATH_CODES} because the remedy is the
 * opposite: the session is alive and it is the page's copy of the token that
 * is stale, so the answer is to re-read the session rather than to clear
 * everything and send the person back to the sign-in page.
 */
const STALE_CSRF_CODES = new Set([
	'auth_csrf_invalid',
	'backoffice_csrf_invalid'
])

export function isStaleCsrfCode(code: string | undefined) {
	return code !== undefined && STALE_CSRF_CODES.has(code)
}
